import './styles/scrollToTop.scss';
import './scrollToTop.js';
import './directives/scrollToTopDirectives.js';